// Deferred loading
import "lazysizes";
import "lazysizes/plugins/bgset/ls.bgset";
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";
import "lazysizes/plugins/custommedia/ls.custommedia";
import Player from "@vimeo/player";

import { initContentGrid } from "./modules/content-grid.js";
import {
  initScrollHandlers,
  checkIfMenuOverlapsContentGrid
} from "./modules/scroll-handlers.js";
import { initRelatedArticles } from "./modules/related-articles.js";

// Platform check
var mac = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
if (mac) {
  document.body.classList.add("is-mac");
}

// Callback for Cookie Consent plugin
// window.CookieLawInfo_Accept_Callback = function () {
//   if (typeof CLI.consent !== "undefined" && CLI.consent.non_necessary === true) {
//     // Continue loading blocked scripts
//     yett.unblock();
//   }
// }

function refreshReverseArray() {
  window.reverseArray = Array();
  jQuery(".section-wrapper--black, .section-wrapper.background-black").each(
    function() {
      reverseArray.push({
        mobileOnly: false,
        top: jQuery(this).offset().top,
        height: jQuery(this).height()
      });
    }
  );
  jQuery(".section-wrapper--case-listing").each(function() {
    reverseArray.push({
      mobileOnly: true,
      top: jQuery(this).offset().top,
      height: jQuery(this).height()
    });
  });
}

(function($) {
  // CookieLawInfo_Accept_Callback();

  // Cookie accept and reject handlers
  // $(document).on('click', '[data-cli_action="accept"]', function() {
  //   console.log('accepted');
  // });
  // $(document).on('click', '[data-cli_action="reject"]', function() {
  // Do something when rejected
  // });

  $.fn.shuffle = function() {
    var p = this[0];
    for (var i = p.children.length; i >= 0; i--) {
      p.appendChild(p.children[(Math.random() * i) | 0]);
    }
  };

  initContentGrid($);

  $(".main-logo").addClass("loaded");

  $("#burger").click(burgerClicked);

  // LazyLoad listeners
  $(".lazyload, .lazyloading").on("lazyloaded", function() {
    $(this)
      .parent()
      .addClass("image-lazyloaded");
  });

  // Make sure cached images also fires this off
  $(".lazyloaded", function() {
    $(this)
      .parent()
      .addClass("image-lazyloaded");
  });

  refreshReverseArray();

  $(".section-wrapper--video").on("DOMSubtreeModified", function() {
    refreshReverseArray();
  });

  initScrollHandlers($);

  $(".vimeo-player").each(function(index) {
    let video_id = $(this).data("video-id");
    const video_autoplay = !!$(this).data("video-autoplay");
    const video_loop = !!$(this).data("video-loop");
    const video_muted = !!$(this).data("video-muted");
    const video_controls = !!$(this).data("video-controls");
    const video_background = !!$(this).data("video-background");

    if (isNaN(video_id)) {
      video_id = Number(video_id.replace(/\D/g, ""));
    }

    const options = {
      id: video_id,
      width: 1900,
      autoplay: true,
      loop: true,
      muted: true,
      controls: false,
      background: true,
      responsive: true
      // width: 1900,
      // autoplay: video_autoplay,
      // loop: video_loop,
      // muted: video_muted,
      // controls: video_controls,
      // background: video_background,
      // responsive: true
    };

    const player = new Player($(this)[0], options);
  });

  initRelatedArticles($);

  // Grid for design debugging
  $("#grid-toggle").on("click", function() {
    $(".grid-desktop").toggleClass("off");
  });

  $(window).keyup(function(e) {
    if (e.keyCode == 27) {
      if ($(".main-menu__container").hasClass("active")) {
        $(".main-menu__container, .menu-burger").removeClass("active");
        $(".wrapper").removeClass("blur");
        $(".main-logo").removeClass("on-menu");
      }
    }
  });

  $(".main-menu__container__overlay-bg").click(function() {
    console.log("hello?");
    $(".main-menu__container, .menu-burger").removeClass("active");
    $(".wrapper").removeClass("blur");
    $(".main-logo").removeClass("on-menu");
  });

  // Mobile grid container menu
  $(".grid-filter__text").click(function(e) {
    e.preventDefault();
    if ($(window).scrollTop() < $(".wrapper-grid-filter").offset().top) {
      $("html, body").animate(
        {
          scrollTop: $(".content-grid").offset().top
        },
        250,
        () => {
          $(".main-menu__container, .menu-burger").addClass(
            "active show-grid-container"
          );
          $(".wrapper").addClass("blur");
          $(".main-logo").addClass("on-menu hidden");
        }
      );
    } else {
      $(".main-menu__container, .menu-burger").addClass(
        "active show-grid-container"
      );
      $(".wrapper").addClass("blur");
      $(".main-logo").addClass("on-menu hidden");
    }
  });

  $(window).resize(function() {
    checkIfMenuOverlapsContentGrid();
  });

  function burgerClicked(e) {
    // In case we may have selected the filter menu
    if (
      $(".grid-filter__text").length &&
      $(".main-menu__container:not(.active)").length
    ) {
      $(".main-menu__container, .menu-burger").removeClass(
        "show-grid-container"
      );
      $(".main-logo").removeClass("hidden");
    }

    $(".main-menu__container, .menu-burger").toggleClass("active");
    $(".wrapper").toggleClass("blur");
    $(".main-logo").toggleClass("on-menu");
  }
})(jQuery);



// WEBPACK FOOTER //
// ./assets/js/main.js